import { api } from './http'

export interface EventItem {
  id: number
  name: string
  location: string
  date: string
  type?: string
  distance?: string
  signup_deadline?: string
  website?: string
  banner_url?: string
  price_base?: number
}

export interface Paginated<T> {
  total: number
  page: number
  page_size: number
  items: T[]
}

export const eventsApi = {
  list: (page = 1, pageSize = 20) => api.get<Paginated<EventItem>>(`/events?page=${page}&page_size=${pageSize}`),
  listFilter: (
    page = 1,
    pageSize = 20,
    params?: { q?: string; type?: string; city?: string }
  ) => {
    const qs = new URLSearchParams({ page: String(page), page_size: String(pageSize) })
    if (params?.q) qs.set('q', params.q)
    if (params?.type) qs.set('type', params.type)
    if (params?.city) qs.set('city', params.city)
    return api.get<Paginated<EventItem>>(`/events?${qs.toString()}`)
  },
  meta: () => api.get<{ types: string[]; cities: string[] }>(`/events/meta`),
}
